<template>
  <div>
    <div class="ic">
      <i class="icon iconfont icon-kulian"></i>
    </div>
    <div class="info">{{msg}}</div>
    <div class="info">请联系对应客服进行咨询</div>
  </div>
</template>

<script>
export default {
    props:['msg']
};
</script>

<style lang="less" scoped>
.ic {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 100px;
    color: #ccc;
  }
}
.info{
  text-align: center;
  margin: 10px 0;
  font-size: 16px;
  color: rgb(0, 195, 255);
}
</style>
